module.exports = __webpack_public_path__ + "img/bucharest-summit.70886003.png";